var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgDiscoBall = function SvgDiscoBall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#disco-ball_svg__a)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.688 9.463a5.85 5.85 0 1 0 11.7 0 5.85 5.85 0 0 0-11.7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78 15.304c1.576-.961 2.682-3.215 2.682-5.842 0-2.626-1.11-4.886-2.689-5.844M6.537 3.612V.688M6.296 15.304c-1.576-.961-2.683-3.215-2.683-5.841 0-2.627 1.11-4.888 2.69-5.846M11.412.688v1.95M10.438 1.663h1.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.338 3.613v1.95",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.363 4.587h1.95M.688 9.462c0 .518.616 1.014 1.713 1.38 1.097.365 2.585.57 4.136.57 1.552 0 3.04-.205 4.137-.57 1.097-.366 1.713-.862 1.713-1.38 0-.517-.616-1.013-1.713-1.378-1.097-.366-2.585-.572-4.136-.572-1.552 0-3.04.206-4.137.572-1.097.365-1.713.861-1.713 1.378Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "disco-ball_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDiscoBall);
export default ForwardRef;